import React from 'react';
import { toast } from 'react-hot-toast';
import { RefreshCw } from 'lucide-react';
import { apiPostJson as apiPost } from '../../../../../../utils/api';

const STATUSES = ['', 'pending', 'approved', 'denied', 'invited', 'active'];

export default function CompFilters({ filters, onChange }) {
  const set = (patch) => onChange({ ...filters, ...patch });

  const sync = async () => {
    try {
      await apiPost('/admin/service_comp_candidates/import');
      toast.success('Refreshing candidates from the processor…');
    } catch (e) {
      toast.error('Could not start sync');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <select
        value={filters.status}
        onChange={(e) => set({ status: e.target.value })}
        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-800 dark:text-white"
      >
        {STATUSES.map((s) => <option key={s} value={s}>{s === '' ? 'All statuses' : s}</option>)}
      </select>
      <label className="flex items-center gap-1 text-sm dark:text-gray-200">
        <input type="checkbox" checked={filters.eligible} onChange={(e) => set({ eligible: e.target.checked })} /> Eligible only
      </label>
      <label className="flex items-center gap-1 text-sm dark:text-gray-200">
        <input type="checkbox" checked={filters.standalone} onChange={(e) => set({ standalone: e.target.checked })} /> Standalone only
      </label>
      <input
        value={filters.q}
        onChange={(e) => set({ q: e.target.value })}
        placeholder="Search company…"
        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-800 dark:text-white flex-1 min-w-[160px]"
      />
      <button onClick={sync} className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm">
        <RefreshCw size={16} /> Sync from processor
      </button>
    </div>
  );
}
